import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const StatementPeriodControl = ({ startDate, endDate, onStartDateChange, onEndDateChange, onApply }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-secondary/10 rounded-md flex items-center justify-center">
          <Icon name="Calendar" size={20} color="var(--color-secondary)" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg">Statement Period</h3>
          <p className="caption text-muted-foreground">Define reconciliation date range</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <Input
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e?.target?.value)}
          required
        />
        <Input
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e?.target?.value)}
          required
        />
      </div>
      <Button 
        variant="default" 
        onClick={onApply}
        iconName="Filter"
        iconPosition="left"
        fullWidth
      >
        Apply Period
      </Button>
    </div>
  );
};

export default StatementPeriodControl;